"use strict";

exports.__esModule = true;
var _LegacyContext = require("./LegacyContext");
Object.keys(_LegacyContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LegacyContext[key]) return;
  exports[key] = _LegacyContext[key];
});
var _LegacyController = require("./LegacyController");
Object.keys(_LegacyController).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LegacyController[key]) return;
  exports[key] = _LegacyController[key];
});